<ng-container [formGroup]="formGroup">
    <ng-container *ngrxLet="list$ as list">
        <cdk-virtual-scroll-viewport itemSize="83" minBufferPx="830" maxBufferPx="1660" [ngStyle]="styles">
            <ul class="list-group ui-sortable" cdkDropList [cdkDropListData]="list" (cdkDropListDropped)="dropBasketRaffleItem($event, list)">
                <li class="list-group-item" *cdkVirtualFor="let element of list;index as i;" cdkDragLockAxis="y" cdkDrag [cdkDragData]="element"
                    (cdkDragStarted)="onCDKDragStarted($event)" (cdkDragEnded)="onCDKDragEnded($event)">
                    <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
                    <div class="preset-option d-flex">
                        <div class="preset-option__drag-and-drop d-flex align-items-center justify-content-center">
                            <app-icon-menu></app-icon-menu>
                        </div>
                        <div class="preset-option__content d-flex align-items-center">
                            <div class="preset-option__number">{{element.index + 1}}.</div>
                            <img [src]="getBasketRaffleItemImageUrl(element.data)" alt="thumbnail" class="preset-option__image">
                            <div class="preset-option__container d-flex flex-column">
                                <div class="preset-option__name mb-1">{{element.data.name}}</div>    
                            </div>
                            <div class="preset-option__actions">
                                <div class="preset-option__action">
                                    <app-move-to [index]="element.index" (onMoveTo)="moveTo($event, list)"></app-move-to>
                                </div>
                                <div class="preset-option__action" (click)="editBasketRaffleItem(element)">
                                    <app-icon-pen [invalid]="element.invalid"></app-icon-pen>
                                </div>
                                <div class="preset-option__action position-relative cursor-default">
                                    <app-icon-trash [invalid]="element.invalid"></app-icon-trash>
                                    <app-campaign-option-action-popover (popoverClicked)="removeBasketRaffleItem($event)" [element]="element" [text]="'Confirm delete?'" [textClasses]="'red-text'" class="position-absolute w-100 h-100"></app-campaign-option-action-popover>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
    
            <div class="preset-option__empty" *ngIf="campaignBasketRaffleItemListService.list.length < 1">Click <b>+ Add</b> to start adding your basket raffle items</div>
        </cdk-virtual-scroll-viewport>
    </ng-container>
</ng-container>
